import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { CidadeProvider } from './context/CidadeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PWAInstallBanner } from './components/PWAInstallBanner';
import Home from './pages/Home';
import Buscar from './pages/Buscar';
import ProfissionalPerfil from './pages/ProfissionalPerfil';
import ProfissionalEntrar from './pages/ProfissionalEntrar';
import ProfissionalCadastro from './pages/ProfissionalCadastro';
import ProfissionalDashboard from './pages/ProfissionalDashboard';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminCidades from './pages/AdminCidades';
import AdminProfissionais from './pages/AdminProfissionais';
import AdminAnuncios from './pages/AdminAnuncios';
import AdminPromocoes from './pages/AdminPromocoes';
import AdminAnunciantes from './pages/AdminAnunciantes';
import AdminCategorias from './pages/AdminCategorias';
import AdminTiposEmpresa from './pages/AdminTiposEmpresa';
import AnuncianteEntrar from './pages/AnuncianteEntrar';
import AnuncianteCadastro from './pages/AnuncianteCadastro';
import AnuncianteDashboard from './pages/AnuncianteDashboard';
import './App.css';
import './App.css';

function ComingSoon({ title }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="w-16 h-16 bg-brand-100 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <span className="text-brand-600 font-bold text-2xl">G</span>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">{title || 'Em breve'}</h1>
        <p className="text-gray-500 mb-6">Esta seção está em desenvolvimento.</p>
        <a href="/" className="btn-primary inline-block">Voltar ao início</a>
      </div>
    </div>
  );
}

function ProfissionalProtected({ children }) {
  const { isProfissional, loading } = useAuth();
  if (loading) return null;
  if (!isProfissional) return <Navigate to="/entrar" replace />;
  return children;
}

function AnuncianteProtected({ children }) {
  const { isAnunciante, loading } = useAuth();
  if (loading) return null;
  if (!isAnunciante) return <Navigate to="/anunciante/entrar" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <CidadeProvider>
        <BrowserRouter>
          <PWAInstallBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/buscar" element={<Buscar />} />
            <Route path="/profissional/:slug" element={<ProfissionalPerfil />} />

            <Route path="/entrar" element={<ProfissionalEntrar />} />
            <Route path="/cadastro" element={<ProfissionalCadastro />} />
            <Route path="/dashboard" element={<ProfissionalProtected><ProfissionalDashboard /></ProfissionalProtected>} />

            <Route path="/anunciante/entrar" element={<AnuncianteEntrar />} />
            <Route path="/anunciante/cadastro" element={<AnuncianteCadastro />} />
            <Route path="/anunciante/dashboard" element={<AnuncianteProtected><AnuncianteDashboard /></AnuncianteProtected>} />
            <Route path="/anunciante" element={<Navigate to="/anunciante/entrar" replace />} />

            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/cidades" element={<AdminCidades />} />
            <Route path="/admin/profissionais" element={<AdminProfissionais />} />
            <Route path="/admin/anuncios" element={<AdminAnuncios />} />
            <Route path="/admin/promocoes" element={<AdminPromocoes />} />
            <Route path="/admin/anunciantes" element={<AdminAnunciantes />} />
            <Route path="/admin/categorias" element={<AdminCategorias />} />
            <Route path="/admin/tipos-empresa" element={<AdminTiposEmpresa />} />

            <Route path="/promocoes" element={<ComingSoon title="Promoções do Mês — Em breve" />} />
            <Route path="/sobra-de-obras" element={<ComingSoon title="Sobra de Obras — Em breve" />} />
            <Route path="/acesso" element={<ComingSoon title="Acesso 24h — Em breve" />} />
            <Route path="*" element={<ComingSoon title="Página não encontrada" />} />
          </Routes>
        </BrowserRouter>
      </CidadeProvider>
    </AuthProvider>
  );
}

export default App;
